<template>
  <div class="product-aside-cart-item">
    <form @submit.prevent>
        <span
          v-if="isB2B"
          class="btn--product-aside btn--product-aside-alt-b2b"
        >
          {{ engraveText }}
        </span>
      <button
        v-else
        type="submit"
        data-test="engravingButton"
        class="btn--product-aside btn--product-aside-alt"
        :class="{ 'btn--product-aside-disabled': engraveDisabled }"
        :disabled="engraveDisabled"
        @click="triggerPersonalisationModel"
      >
        {{ engraveText }}
      </button>
    </form>
  </div>
</template>

<script>
import events from "Assets/js/components/events";
import globalTheme from 'Assets/js/components/globalTheme';
import { mapGetters } from "vuex";
import cartContent from "Templates/content/cart.json";
import engravingHelper from "Assets/js/components/helpers/engravingHelper";

export default {
  name: "addToCart",
  props: {
    selectedVariant: String,
    selectedVariantInStock: {
      type: Boolean,
      default: null
    },
    product: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      count: 1,
      min: 1,
      max: 99,
      disable_addition: false,
      disabledButton: false,
      product_id: '',
      addingToCart: false,
      show: {
        add_to_cart: true,
        personalisation: false,
        engraving: false
      },
      engraving: {
        product: {
          price: {
            amount: "0.00"
          }
        }
      },
      engraving_initialised: false,
      selected: '',
      dropdownTitle: 'Choose An Option',
      has_variants: false,
      activedropdown: false,
      personalisationlimit: 20,
      requires_personalisation: false,
      cart_has_max_items_already: false,
    }
  },
  computed: {
    ...mapGetters([
      'cartInstance',
      'userInstance',
      'isB2B',
    ]),
    dropdowncss() {
      if (this.activedropdown) {
        return 'variant-dropdown variant-dropdown--active zmdi zmdi-chevron-up'
      } else {
        return 'variant-dropdown variant-dropdown--inactive zmdi zmdi-chevron-down'
      }
    },
    selectedVariantRecord() {
      return (this.product.product_variants || []).find((variant) => variant.id === this.selectedVariant);
    },
    selectedVariantAvailable() {
      if (typeof this.selectedVariantInStock === "boolean") {
        return this.selectedVariantInStock;
      }
      if (this.selectedVariantRecord && typeof this.selectedVariantRecord.availableForSale === "boolean") {
        return this.selectedVariantRecord.availableForSale;
      }
      const fallbackVariant = (this.product.product_variants || [])[0];
      if (fallbackVariant && typeof fallbackVariant.availableForSale === "boolean") {
        return fallbackVariant.availableForSale;
      }
      return true;
    },
    engraveText(){
      const engravingAmount = parseFloat(this.engraving.product.price.amount || 0);

      if (this.cart_has_max_items_already) {
        return cartContent.product.has_max_in_cart_already;
      }

      if (!this.engraving_initialised) {
        return 'Engrave this product';
      }

      if (globalTheme.cartEngraveButtonWithPrice() && this.engraving.product.price.amount) {
        const freeCustomisation = globalTheme.freeEngraveButtonCustomisation();
        if (engravingAmount === 0 && freeCustomisation) {
          return freeCustomisation;
        }

        const customisation = globalTheme.cartEngraveButtonCustomisation();
        if (customisation) {
          return 'Engrave for ' + globalTheme.formatPrice(parseFloat(globalTheme.doVat(this.engraving.product.price.amount) )) + (customisation ? ' ' + customisation: '');
        }
        return 'Engrave this ' + this.engraving.engraving_type + ' for ' + globalTheme.formatPrice(parseFloat(globalTheme.doVat(this.engraving.product.price.amount) ));
      }
      if(this.isB2B){
        return 'Add to bag to engrave';
      }

      if(!globalTheme.cartEngraveButtonWithPrice() && globalTheme.cartEngraveButtonCustomisation && this.engraving.engraving_type === "bottle" ){
        return globalTheme.cartEngraveButtonCustomisation();
      }

      if(!globalTheme.cartEngraveButtonWithPrice() && globalTheme.cartEngraveButtonCustomisation && this.engraving.engraving_type !== "bottle" ){
        return 'Engrave this ' + this.engraving.engraving_type + ' for ' + globalTheme.formatPrice(parseFloat(globalTheme.doVat(this.engraving.product.price.amount) ));
      }

      return 'Click here to engrave';
    },
    engraveDisabled() {
      return !!this.isB2B || !this.selectedVariantAvailable || this.cart_has_max_items_already;
    },
    cartLabel() {
      return this.addingToCart ? cartContent.product.adding : cartContent.product.add_to_bag;
    },
    personalisationLabel() {
      return this.isB2B ? cartContent.product.add_and_personalise : cartContent.product.personalise;
    }
  },
  methods: {
    triggerPersonalisationModel() {
      if (this.isB2B) {
        this.addThisToCart(function() {
          events.cartShow();
        });
        return;
      }

      if (!this.selectedVariantAvailable) {
        return;
      }

      window.dispatchEvent(
        new CustomEvent('togglePersonalisationPreview', {})
      )

      if(this.has_variants){
        this.cartInstance.toggleVariantPersonalisationModel(
          this.selectedVariant,
          this.product.shopify_id,
          this.product.shopify_title,
          this.product.featuredImage.src,
          this.personalisationlimit,
          this.product.product_variants,
          this.engraving
        );
        return;
      }

      this.cartInstance.togglePersonalisationModel(
        this.selectedVariant,
        this.product.shopify_id,
        this.product.shopify_title,
        this.product.featuredImage.src,
        this.personalisationlimit,
        this.engraving
      );
    },
    /**
     * @param {Function|undefined} callback
     */
    addThisToCart(callback) {
      const count = this.count;
      this.addingToCart = true;
      this.disabledButton = true;
      this.cartInstance.addToCart(selected_variant, count, this.product_id, (responseData) => {
        if (responseData.status === 200) {
          this.addingToCart = false;
          this.disabledButton = false;
          events.cartChange();
          this.count = 1;
          if (typeof callback === "function") {
            callback();
          }
          if (this.isB2B) {
            events.cartShow();
          }
        }
      });
    },
  },
  beforeMount() {
    const hasEngraving = this.product.shopify_metafields.engraving?.available ?? false;
    const engravingProduct = hasEngraving ? (this.product.shopify_metafields.engraving?.product ?? null) : null;
    this.has_variants = Array.isArray(this.product.product_variants) && this.product.product_variants.length > 1;

    this.engraving.type = engravingProduct;
    this.engraving.limit = this.product.shopify_metafields.personalisation_limit;
    this.cartInstance.getEngravingProduct(engravingProduct, (responseData) => {
      if(responseData){
        this.engraving.product =  responseData;
        this.engraving.product.id =  responseData?.id.edges[0].node.id;
        this.engraving.product.price = responseData?.price.edges[0].node.priceV2;
        this.engraving.engraving_type = engravingHelper.getEngravingType(responseData?.title);
        this.engraving_initialised = true;
      }
    });

    this.product_id = this.product.shopify_id;

    if(this.requires_personalisation === true){
      this.show.personalisation = true;
      this.show.add_to_cart = false;
    }
    if(this.product.shopify_metafields?.engraving?.product && !this.requires_personalisation ){
      this.show.engraving = true;
    }

    window.addEventListener(
      'cartService:cartFetched',
      () => {
        this.cart_has_max_items_already = this.cartInstance.doesCartHaveMaxQuantityOfProduct(this.product);
      }
    );
  },
  mounted() {
    this.cart_has_max_items_already = this.cartInstance.doesCartHaveMaxQuantityOfProduct(this.product);
  }
}
</script>
